import { logger as r } from "../../shared-lib/index.js";
import FeatureFlag from "./feature-flag.js";
export function newFeatureFlagFromJson(e) {
  if (e[FeatureFlag._t.ht] && "boolean" == typeof e[FeatureFlag._t.le])
    return new FeatureFlag(
      e[FeatureFlag._t.ht],
      e[FeatureFlag._t.le],
      e[FeatureFlag._t.pe],
      e[FeatureFlag._t.Fe],
    );
  r.info(`Unable to create feature flag from ${JSON.stringify(e, null, 2)}`);
}
export function newFeatureFlagFromSerializedValue(e) {
  if (e[FeatureFlag.tt.ht] && "boolean" == typeof e[FeatureFlag.tt.le])
    return new FeatureFlag(
      e[FeatureFlag.tt.ht],
      e[FeatureFlag.tt.le],
      e[FeatureFlag.tt.pe],
      e[FeatureFlag.tt.Fe],
    );
  r.info(
    `Unable to deserialize feature flag from ${JSON.stringify(e, null, 2)}`,
  );
}
